export type FBValidatorDelimiter = ':' | ',';

export enum FBValidatorTrigger {
  // ON_SUBMIT = "Submit",
  // ON_CHANGE = "Change",
  ON_STATE_TO_IN_REVIEW = 'trigger on state to in review',
}
